import { renderAttributes } from "./render/mod.js";
import { createFragmentDeclarationFromMarkup, createUnescapedString, isKnytContent, } from "./utils/mod.js";
export const markupTemplateTag = function markupTemplateTag(markup, ...values) {
    const resolvedValues = values.map((value) => {
        if (isKnytContent(value)) {
            return value;
        }
        return createUnescapedString(renderAttributes(value).join(" "));
    });
    return createFragmentDeclarationFromMarkup(markup, resolvedValues);
};
